import { lazy } from '@loadable/component';

// Ruta base del template
const App = lazy(() => import('./views/App/App'));

// Rutas adicionales generadas
const QuickRegistration = lazy(() => import('./views/QuickRegistration'));
const ProviderLogin = lazy(() => import('./views/ProviderLogin'));
const PreofferEvaluation = lazy(() => import('./views/PreofferEvaluation'));
const ChangeAssignmentCessionType = lazy(() => import('./views/ChangeAssignmentCessionType'));
const AutomaticCessionConfig = lazy(() => import('./views/AutomaticCessionConfig'));
const Terms = lazy(() => import('./views/Terms'));
const PasswordRecovery = lazy(() => import('./views/PasswordRecovery'));
const EmailVerification = lazy(() => import('./views/EmailVerification'));
const OtpVerification = lazy(() => import('./views/OtpVerification'));
const LandingRegister = lazy(() => import('./views/LandingRegister'));
const LandingRegisterWhatsapp = lazy(() => import('./views/LandingRegisterWhatsapp'));
const LokalProviders = lazy(() => import('./views/LokalProviders'));
const SimulatorRegisterVideo = lazy(() => import('./views/SimulatorRegisterVideo'));
const KobrosRegister = lazy(() => import('./views/KobrosRegister'));
const CollectionRegister = lazy(() => import('./views/CollectionRegister'));
const Evaluate = lazy(() => import('./views/Evaluate'));
const EvaluateInvoices = lazy(() => import('./views/EvaluateInvoices'));
const PromoOperation = lazy(() => import('./views/PromoOperation'));
const UserRegister = lazy(() => import('./views/UserRegister'));
const UserLogin = lazy(() => import('./views/UserLogin'));

const appRoutes = [
  { path: '/app', component: App, private: true },
  { path: '/quick-registration', component: QuickRegistration },
  { path: '/provider-login', component: ProviderLogin },
  { path: '/preoffer-evaluation/:preofferHash', component: PreofferEvaluation },
  { path: '/change-assignment-cession-type/:invoiceHash', component: ChangeAssignmentCessionType },
  { path: '/automatic-cession-config/:automaticCessionConfigHash', component: AutomaticCessionConfig },
  { path: '/terms', component: Terms },
  { path: '/password-recovery', component: PasswordRecovery },
  { path: '/email-verification/:encodedEmail/:token', component: EmailVerification },
  { path: '/otp-verification/:clientId', component: OtpVerification },
  { path: '/landing-register', component: LandingRegister },
  { path: '/landing-register-whatsapp', component: LandingRegisterWhatsapp },
  { path: '/lokal-providers', component: LokalProviders },
  { path: '/simulator-register-video', component: SimulatorRegisterVideo },
  { path: '/kobros-register', component: KobrosRegister },
  { path: '/collection-register', component: CollectionRegister },
  { path: '/evaluate', component: Evaluate },
  { path: '/evaluate-invoices', component: EvaluateInvoices },
  { path: '/promo-operation', component: PromoOperation },
  { path: '/user-register', component: UserRegister },
  { path: '/user-login', component: UserLogin },
];

export default appRoutes;
